import Main from './ContractInvoicesMain'

const ContractInvoices = {
  Main,
}

export default ContractInvoices
